import { useState } from "react";
import "../cellUnit.css";
export type ActionCellProps = {
  value: any;
  icon: string;
  tooltipText: string;
  onClicked: () => void;
};

const ActionCell: React.FC<ActionCellProps> = ({ value, icon, tooltipText, onClicked }) => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  return (
    <div className="cell-unit">
      <div className={isTooltipVisible ? "tooltip visible label-small" : "tooltip label-small"}>{tooltipText}</div>
      <div className="overlay"></div>

      <button
        onClick={() => {
          if (value !== "" && value) {
            setTooltipVisible(true);

            setTimeout(() => {
              setTooltipVisible(false);
            }, 1000);
            onClicked();
          }
        }}
        className="cell-action-button"
      >
        {value !== "" && value && (
          <>
            <div className="action-overlay"></div>
            <div className="content">
              <span className="body-medium">{value}</span>
              <img alt="cell action icon" src={icon} className="icon"></img>
            </div>
          </>
        )}
      </button>
    </div>
  );
};

export default ActionCell;
